import { render, staticRenderFns } from "./PreviewImage.vue?vue&type=template&id=4065782a&scoped=true&"
import script from "./PreviewImage.vue?vue&type=script&lang=js&"
export * from "./PreviewImage.vue?vue&type=script&lang=js&"
import style0 from "./PreviewImage.vue?vue&type=style&index=0&id=4065782a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4065782a",
  null
  
)

export default component.exports